import { CollapsibleBox } from "imagine-ui";
import { DefectStatusEntry, PunchlistText, StatusIcon } from "../..";
import { useTranslation } from "react-i18next";
import { DateTimeFormat, DateTimeText } from "imagine-datetime";
import { UserRole } from "imagine-users";

interface Props {
  history: DefectStatusEntry[];
  className?: string;
}

export const StatusHistory = (props: Props) => {
  const { t } = useTranslation();
  return (
    <div className={props.className}>
      <CollapsibleBox title={t("punchlist:statusHistory")} initialOpen>
        <table className="table table-rows">
          <tbody>
            {props.history.map((entry, index) => (
              <tr key={index}>
                <td>
                  <StatusIcon status={entry.status} />
                </td>
                <td>
                  <span className="text-bold pr">
                    {PunchlistText.getRoleTextNoAdmin(
                      entry.userRole || UserRole.NONE
                    )}
                  </span>
                  <span className="text-dark-muted d-none--sm">
                    {DateTimeText.getDbDateTimeText(
                      entry.dateCreated || "",
                      DateTimeFormat.LONG_DATE_AND_TIME
                    )}
                  </span>
                </td>
                <td>
                  <span>{entry.text}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CollapsibleBox>
    </div>
  );
};
